import {
    CLEAR_KMS_TAXONOMY_ERROR,
    CLEAR_KMS_TAXONOMY_MESSAGE,
    GET_KMS_CATEGORIES_FAIL,
    GET_KMS_CATEGORIES_SUCCESS,
    GET_KMS_TAGS_FAIL,
    GET_KMS_TAGS_SUCCESS,
    GET_KMS_TAXONOMY_OPTIONS_FAIL,
    GET_KMS_TAXONOMY_OPTIONS_SUCCESS,
    SET_KMS_TAXONOMY_LOADING,
    SET_KMS_TAXONOMY_SAVING,
} from "../actions/kmsTaxonomyActions";

const initialState = {
    loading: false,
    saving: false,
    categories: [],
    tags: [],
    options: {
        categories: [],
        tags: [],
    },
    error: null,
    message: "",
};

export default function kmsTaxonomyReducer(state = initialState, action) {
    switch (action.type) {
        case SET_KMS_TAXONOMY_LOADING:
            return { ...state, loading: action.payload };

        case SET_KMS_TAXONOMY_SAVING:
            return { ...state, saving: action.payload };

        case GET_KMS_TAXONOMY_OPTIONS_SUCCESS:
            return {
                ...state,
                options: {
                    categories: action.payload?.categories || [],
                    tags: action.payload?.tags || [],
                },
                error: null,
            };

        case GET_KMS_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: action.payload || [],
                error: null,
                message: action.meta?.message || state.message,
            };

        case GET_KMS_TAGS_SUCCESS:
            return {
                ...state,
                tags: action.payload || [],
                error: null,
                message: action.meta?.message || state.message,
            };

        case GET_KMS_TAXONOMY_OPTIONS_FAIL:
        case GET_KMS_CATEGORIES_FAIL:
        case GET_KMS_TAGS_FAIL:
            return { ...state, error: action.error };

        case CLEAR_KMS_TAXONOMY_ERROR:
            return { ...state, error: null };

        case CLEAR_KMS_TAXONOMY_MESSAGE:
            return { ...state, message: "" };

        default:
            return state;
    }
}
